'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default ['$scope', '$uibModalInstance', 'transaction', '$security',
    function($scope, $modalInstance, transaction, $security) {
        $scope.ok = ok;
        $scope.cancel = cancel;

        // инициализация
        init();

        // region Function

        function init() {
            $scope.transaction = angular.copy(transaction);
            $scope.title = 'Отклонить запрос';
        }

        function ok(item) {
            $modalInstance.close(item);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        // endregion
    }];
